import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-red-600 text-white text-center" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-46">
          <h2 className="text-4xl md:text-6xl font-black mb-6 uppercase tracking-tight" data-id="element-47">
            🥗 Tu cambio empieza hoy
          </h2>

          <div className="text-2xl md:text-3xl font-bold mb-10 space-y-2" data-id="element-48">
            <p data-id="element-49">No necesitás más fuerza de voluntad.</p>
            <p className="text-yellow-300" data-id="element-50">Necesitás un sistema.</p>
            <p className="text-xl md:text-2xl mt-4 bg-black/20 inline-block px-6 py-2 rounded-full" data-id="element-51">
              Y ya lo tenés acá.
            </p>
          </div>

          <CtaButton text="👉 QUIERO EMPEZAR AHORA" className="shadow-[0_0_40px_rgba(253,224,71,0.4)] hover:shadow-[0_0_60px_rgba(253,224,71,0.6)]" data-id="element-52" />
        </motion.div>
      </div>
    </section>;
}